import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Button } from '@material-ui/core'
import { navigate } from '@reach/router'

import { getWorkflowSteps } from '../../store/workflow/selectors'
import { getAppPDV } from '../../store/app/selectors'

export const computeUrl = (baseUrl, pdvID) => {
  if (pdvID === null) return baseUrl
  return baseUrl + `?pdv=${pdvID}`
}

export class BackButton extends Component {
  render() {
    const { pdvID, targetStep, steps, children } = this.props
    const url = computeUrl(steps[targetStep].url, pdvID)
    return (
      <Button variant="contained" color="primary" onClick={() => navigate(url)}>
        {children}
      </Button>
    )
  }
}

const mapStateToProps = state => ({
  steps: getWorkflowSteps(state),
  pdvID: getAppPDV(state)
})

export const LinkedBackButton = connect(mapStateToProps)(BackButton)
